import { categoryMap } from '$lib/global/tracking/integrations';

import type { IntegrationCategory, IntegrationData } from '$lib/components/ConsentOverlay/types';

export const getIntegrationsByCategory = (
    integrations: string[],
    category: IntegrationCategory,
) => {
    const list: string[] = [];

    integrations.forEach((integration) => {
        if (categoryMap[category].includes(integration)) {
            list.push(integration);
        }
    });

    return list;
};

/**
 * Detects whether a new consent selection revokes an integration that was
 * previously granted.
 *
 * Third-party integrations (e.g. Google Analytics, Facebook Pixel) are loaded
 * into `window.analytics` on acceptance and cannot be torn down at runtime, so a
 * downgrade requires a page reload to fully stop them. See FUN-3737.
 */
export const isConsentDowngrade = (
    previousSelection: Record<string, unknown>,
    nextSelection: Record<string, unknown>,
) =>
    Object.keys(previousSelection).some(
        (integration) => Boolean(previousSelection[integration]) && !nextSelection[integration],
    );

export const getActiveIntegrations = (
    selectedIntegrations: IntegrationData,
    integrationData: IntegrationData,
) => {
    const activeIntegrations: IntegrationData = {};

    Object.keys(selectedIntegrations).forEach((displayName) => {
        const enabled = selectedIntegrations[displayName];

        if (enabled) {
            activeIntegrations[displayName] = integrationData[displayName];
        }
    });

    return activeIntegrations;
};
